<template>
  <div class="ins">
    <div v-for="(i, idx) in items" :key="idx" class="insrow" :class="'ins-' + i.s">
      <span class="insic">{{ i.ic }}</span>
      <span class="tx" v-html="i.html" />
      <a v-if="i.view" @click.prevent="$emit('navigate', i.view)">{{ t('ex_more') }}</a>
    </div>
    <div v-if="!items.length" class="sd-hint">{{ t('no_data') }}</div>
  </div>
</template>
<script>
import { sdMixin } from '../store.js'
export default { name: 'SdInsightList', mixins: [sdMixin], props: { items: { type: Array, default: () => [] } } }
</script>
